import { render, staticRenderFns } from "./editPassword.vue?vue&type=template&id=cd962d32&scoped=true&"
import script from "./editPassword.vue?vue&type=script&lang=js&"
export * from "./editPassword.vue?vue&type=script&lang=js&"
import style0 from "./editPassword.vue?vue&type=style&index=0&id=cd962d32&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cd962d32",
  null
  
)

export default component.exports